import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export const generateAnonymousParticipants = async (
    workshopId: string,
    count: number,
    roles: string,
    clusteringMethod: string
) => {
    console.log('Dummy API call to generate anonymous participants', {
        workshopId,
        count,
        roles,
        clusteringMethod,
    });
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));
    return { success: true };
};

export const syncWorkshop = async (workshopKey: string) => {
    try {
        if (!functions) {
            throw new Error("Firebase functions not initialized");
        }
        const workshopServiceCallable = httpsCallable<unknown, any>(functions, 'workshopService');
        const result = await workshopServiceCallable({
            action: "syncWorkshop",
            data: { workshopId: workshopKey }
        });
        return result.data;
    } catch (error) {
        console.error('Error synching workshop:', error);
        throw error;
    }
};